'use strict';

/** @type {import('./uri')} */
module.exports = URIError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/uri.js
// module id = 1547
// module chunks = 1